module.exports = "<!-- TIMELINE --> \n<div #timelineJS3 id=\"phibor-timeline\" style=\"width: 100%; height: 800px\"></div>\n<!-- END // TIMELINE -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/timeline/timeline.component.html
// module id = ./src/app/components/ui/timeline/timeline.component.html
// module chunks = main